var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89.814 44.419 L 80.62 31.535 c -0.188 -0.263 -0.491 -0.419 -0.814 -0.419 H 53.537 h -6.521 c -0.553 0 -1 0.448 -1 1 s 0.447 1 1 1 h 6.006 L 61.503 45 l -8.481 11.885 H 29.211 l 8.066 -11.304 c 0.248 -0.348 0.248 -0.814 0 -1.162 l -8.066 -11.303 h 8.002 c 0.552 0 1 -0.448 1 -1 s -0.448 -1 -1 -1 h -9.944 H 1 c -0.375 0 -0.718 0.209 -0.889 0.542 c -0.171 0.333 -0.143 0.734 0.075 1.039 L 8.965 45 L 0.186 57.304 c -0.218 0.305 -0.247 0.706 -0.075 1.039 S 0.625 58.885 1 58.885 h 10.111 c 0.552 0 1 -0.447 1 -1 s -0.448 -1 -1 -1 H 2.942 l 8.066 -11.304 c 0.248 -0.348 0.248 -0.814 0 -1.162 L 2.942 33.116 h 23.812 L 35.234 45 l -8.481 11.885 h -5.117 c -0.552 0 -1 0.447 -1 1 s 0.448 1 1 1 h 5.632 h 26.269 h 9.408 c 0.553 0 1 -0.447 1 -1 s -0.447 -1 -1 -1 H 55.48 l 8.066 -11.304 c 0.247 -0.348 0.247 -0.814 0 -1.162 L 55.48 33.116 h 23.811 L 87.771 45 l -8.48 11.885 h -6.056 c -0.553 0 -1 0.447 -1 1 s 0.447 1 1 1 h 6.57 c 0.323 0 0.626 -0.156 0.814 -0.419 l 9.194 -12.885 C 90.062 45.233 90.062 44.767 89.814 44.419 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.273 22.197 h 2.1 v 13.771 c 0 0.552 0.448 1 1 1 s 1 -0.448 1 -1 V 22.197 h 1.852 c 0.552 0 1 -0.448 1 -1 v -5.951 c 0 -0.552 -0.448 -1 -1 -1 h -5.951 c -0.552 0 -1 0.448 -1 1 v 5.951 C 38.273 21.749 38.721 22.197 39.273 22.197 z M 40.273 16.246 h 3.951 v 3.951 h -3.951 V 16.246 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 71.617 67.803 h -1.976 v -13.77 c 0 -0.553 -0.447 -1 -1 -1 s -1 0.447 -1 1 v 13.77 h -1.976 c -0.553 0 -1 0.447 -1 1 v 5.951 c 0 0.553 0.447 1 1 1 h 5.951 c 0.553 0 1 -0.447 1 -1 v -5.951 C 72.617 68.25 72.17 67.803 71.617 67.803 z M 70.617 73.754 h -3.951 v -3.951 h 3.951 V 73.754 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.08 67.803 h -1.976 v -13.77 c 0 -0.553 -0.448 -1 -1 -1 s -1 0.447 -1 1 v 13.77 h -1.976 c -0.552 0 -1 0.447 -1 1 v 5.951 c 0 0.553 0.448 1 1 1 h 5.951 c 0.552 0 1 -0.447 1 -1 v -5.951 C 20.08 68.25 19.632 67.803 19.08 67.803 z M 18.08 73.754 h -3.951 v -3.951 h 3.951 V 73.754 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/schedule_icon.cfe86a66ca315d93d3a104419563826a.svg";
export { ForwardRef as ReactComponent };